import type { Product } from '../model/product';

export function productHref(
  product: Pick<Product, 'kind' | 'slug'>,
): '/gift-set' | `/catalog/${string}` {
  return product.kind === 'bundle' ? '/gift-set' : `/catalog/${product.slug}`;
}
